import { useCallback } from 'react'

import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'

function useBedbankSelectDates(roomId?: string) {
  const offerPageDispatch = useOfferPageDispatch()

  const onCalendarOpenSelectDates = useCallback(() => {
    offerPageDispatch({ type: OfferPageActions.toggleFilter, filter: 'checkin' })
    if (roomId) {
      offerPageDispatch({ type: OfferPageActions.setBedbankRoomId, bedbankRoomId: roomId })
    }
  }, [offerPageDispatch, roomId])

  return onCalendarOpenSelectDates
}

export function useBedbankSelectDatesWithFlights(roomId?: string) {
  const offerPageDispatch = useOfferPageDispatch()

  const onCalendarOpenSelectDates = useCallback((withFlights?: boolean) => {
    offerPageDispatch({ type: OfferPageActions.checkAvailability, filter: 'checkin', flights: withFlights })
    if (roomId) {
      offerPageDispatch({ type: OfferPageActions.setBedbankRoomId, bedbankRoomId: roomId })
    }
  }, [offerPageDispatch, roomId])

  return onCalendarOpenSelectDates
}

export default useBedbankSelectDates
